import React from 'react';
import { Container, IconContainer } from './styles'

const renderSvg = (type) => {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="84" height="84" viewBox="0 0 84 84" fill="none">
      <path d="M19.7529 42.526L33.8018 56.5749L63.7981 26.5786" stroke="#A5DC86" stroke-width="3.79699" stroke-linecap="round" />
      <circle cx="41.7757" cy="41.7669" r="39.8684" stroke="#E5E5E5" stroke-width="3.79699" />
    </svg>
  )
}

const Alert = ({ msg, type = 'success' }) => {
  return (
    <Container>
      <IconContainer>
        {renderSvg(type)}
      </IconContainer>
      <p>{msg}</p>
    </Container>
  );
};

export default Alert;
